import React from 'react';
import { Skeleton } from '@mui/material';

import './desktop-product-detail-page-skeleton-style.scss';

import { SKELETON_COLOR } from "@src/utils/constants";

const DesktopProductDetailPageSkeleton = () => {
  return (
    <div id="desktop-product-detail-page-skeleton-wrapper">
      <div className="desktop-product-detail-page-skeleton-content-wrapper">
        <div className="desktop-product-detail-page-skeleton-top-area">
          <Skeleton variant="rectangular" width={85} height={22} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 4 }} />
          <Skeleton variant="rectangular" width={85} height={22} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 4 }} />
          <Skeleton variant="rectangular" width={85} height={22} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 4 }} />
        </div>

        <div className="desktop-product-detail-page-skeleton-main-area">
          <Skeleton variant="rectangular" width={632} height={760} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 6 }} />

          <div className="product-description-skeleton-area">
            <div className="brand-skeleton-wrapper">
              <Skeleton variant="rectangular" width={50} height={50} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 6 }} />
              <Skeleton variant="rectangular" width={107} height={24} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 6 }} />
            </div>

            <div className="price-skeleton-wrapper">
              <div className="name-skeleton-area">
                <Skeleton variant="rectangular" width={426} height={26} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 6 }} />

                <div className="gap-area">
                  <Skeleton variant="circular" width={24} height={24} style={{ backgroundColor: SKELETON_COLOR }} />
                  <Skeleton variant="circular" width={24} height={24} style={{ backgroundColor: SKELETON_COLOR }} />
                </div>
              </div>

              <Skeleton variant="rectangular" width={70} height={23} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 6 }} />

              <Skeleton variant="rectangular" width={214} height={29} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 6, marginTop: 25 }} />
            </div>

            <div className="delivery-skeleton-wrapper">
              <div className="pd-16 bd">
                <Skeleton variant="rectangular" width={180} height={20} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 6 }} />
              </div>


              <div className="pd-16 g-8">
                <div className="space-between-area">
                  <Skeleton variant="rectangular" width={90} height={20} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 6 }} />
                  <Skeleton variant="rectangular" width={50} height={20} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 6 }} />
                </div>

                <div className="space-between-area">
                  <Skeleton variant="rectangular" width={130} height={20} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 6 }} />
                  <Skeleton variant="rectangular" width={24} height={24} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 6 }} />
                </div>
              </div>
            </div>

            <div className="btn-skeleton-area">
              <Skeleton variant="rectangular" height={50} style={{ backgroundColor: SKELETON_COLOR, flex: 1, borderRadius: 30 }} />
              <Skeleton variant="rectangular" height={50} style={{ backgroundColor: SKELETON_COLOR, flex: 1, borderRadius: 30 }} />
            </div>
          </div>
        </div>
      </div>
    </div >
  );
};

export default DesktopProductDetailPageSkeleton;
